import { ModalProps as ModalPropsAd } from "antd";
import React, { ReactChildren } from "react";

import { ConfirmBox as CoeffConfirmBox } from "../../common/ConfirmBox";

// Note: This component just wraps the existing ConfirmBox component
// This is needed as due to some weirdness with JsxParser we had to
// rename onOk and onCancel to handleOk and handleCancel to make the bindings work.

interface ConfirmBoxProps extends ModalPropsAd {
  children?: ReactChildren;
  title: string;
  visible: boolean;
  closable?: boolean;
  okText?: string;
  handleOk?: (args: any) => void;
  cancelText?: string;
  handleCancel?: (args: any) => void;
  submitText?: string;
  handleSubmit?: () => void;
}

export const ConfirmBox = ({
  children,
  handleCancel,
  handleOk,
  handleSubmit,
  ...props
}: ConfirmBoxProps) => {
  return (
    <CoeffConfirmBox onOk={handleOk} onCancel={handleCancel} onSubmit={handleSubmit} {...props}>
      {children}
    </CoeffConfirmBox>
  );
};
